import React from 'react';
import ReactDOM from 'react-dom';
// provider
import Base from './Base';
// styles
import 'styles/main.scss';

ReactDOM.render(
  <React.StrictMode>
    <Base />
  </React.StrictMode>,
  document.getElementById('root'),
);
